import React, { Component } from 'react';
import { IUserMedal } from '@umu/umu-types';
import { getMedalIcon } from '@umu/umu-util';
import { transformPx2Rem } from '../../../../../@utils';
import './index.scss';

interface IUserMedalIconProps {
    userMedalInfo?: IUserMedal;
    userMedalWidth: 20 | 30 | 16 | 12;
}

export default class UserMedalIcon extends Component<IUserMedalIconProps, {}> {
    public render() {
        let size;
        const { userMedalWidth } = this.props;
        if (userMedalWidth) {
            size = {
                width: transformPx2Rem(userMedalWidth + 'px'),
                height: transformPx2Rem(userMedalWidth + 'px'),
            };
        }

        const { userMedalInfo } = this.props;

        if (!userMedalInfo) {
            return null;
        }

        const medalIcon = getMedalIcon(userMedalInfo.medal_type, userMedalInfo.medal_rank, 'S');
        return (
            <div className="umu-user-name__medal" style={size}>
                <img src={medalIcon} alt="" />
            </div>
        );
    }
}
